import styled, { css } from 'styled-components';

interface NotificationTagProps {
  info?: boolean;
  link?: boolean;
  alert?: boolean;
  success?: boolean;
  secondary?: boolean;
  secondaryBlack?: boolean;
}

const backgroundColor = css<NotificationTagProps>`
  background-color: ${({
    info,
    link,
    alert,
    theme,
    success,
    secondary,
    secondaryBlack,
  }) => {
    if (info) {
      return theme.color.info.primary;
    } else if (success) {
      return theme.color.success.primary;
    } else if (alert) {
      return theme.color.alert.primary;
    } else if (secondaryBlack || secondary || link) {
      return 'transparent';
    } else {
      return theme.color.info.primary;
    }
  }};
`;

const NotificationTag = styled('span')<NotificationTagProps>`
  position: relative;
  top: -2px;
  font-size: ${({ theme }) => theme.x1space + 0.2}rem;
  color: white;
  font-weight: 900;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${backgroundColor};
  padding: ${({ theme }) => (theme.x1space - 0.6) * 10}px
    ${({ theme }) => (theme.x1space - 0.4) * 10}px;
`;

export default NotificationTag;
